import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Table from '@cloudscape-design/components/table';
import type { UsageCounters } from '@etiquetachef/types';

type Props = {
  entries: UsageCounters[];
  /** YYYYMM atual (destaca a linha). */
  currentYyyymm: string;
};

/** Tabela mês × etiquetas impressas; marca com ● o mês corrente. */
export function UsageHistoryTable({ entries, currentYyyymm }: Props): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Table<UsageCounters>
      items={entries}
      trackBy="yyyymm"
      variant="embedded"
      empty={<Box textAlign="center" color="inherit">{t('tenantDetail.usageHistory.empty')}</Box>}
      columnDefinitions={[
        {
          id: 'month',
          header: t('tenantDetail.usageHistory.month'),
          cell: (e): React.ReactNode => (
            <span style={{ fontFamily: 'monospace' }}>
              {e.yyyymm}
              {e.yyyymm === currentYyyymm ? ' ●' : ''}
            </span>
          ),
        },
        {
          id: 'printed',
          header: t('tenantDetail.usageHistory.printed'),
          cell: (e): React.ReactNode => e.labelsPrinted,
        },
      ]}
    />
  );
}
